module.exports = __webpack_public_path__ + "static/media/m-new-tentens.03beb3fc.png";